import {ChangeEvent, KeyboardEvent, useContext, useState} from "react";
import {Input} from "@chakra-ui/react";
import {AppContext, AppContextI} from "../context/ContextWrapper";

type Props = {
    beaconAddress?: string,
    index: number,
    onBeaconAddressChange: (beaconAddress: string, index: number) => void,
    inputTestId?: string
}


const regex = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/; // with : delimiter
const regexNoDelimiter = /^([0-9A-Fa-f]{12})$/;

const isBeaconAddressValidOrEmpty = (beaconAddress: string | undefined): boolean => {
    return !beaconAddress
        || regex.test(beaconAddress)
        || regexNoDelimiter.test(beaconAddress)
}

const BeaconAddressInput = ({beaconAddress, onBeaconAddressChange, index, inputTestId}: Props) => {
    const appContext: AppContextI = useContext<AppContextI>(AppContext);
    const [valid, setValid] = useState<boolean>(isBeaconAddressValidOrEmpty(beaconAddress));

    return <>
        <Input size={"sm"}
               data-testid={inputTestId}
               disabled={!appContext.isDraft()}
               defaultValue={beaconAddress}
               maxLength={17}
               width={"130px"}
               style={{
                   color: valid ? "black" : "red"
               }}
               onBlur={(e: ChangeEvent<HTMLInputElement>) => {
                   const nextValue = e.target.value.trim();
                   const isValidNow = isBeaconAddressValidOrEmpty(nextValue);
                   setValid(isValidNow);
                   if (isValidNow) {
                       onBeaconAddressChange(nextValue.toUpperCase(), index);
                   }
               }}
               onChange={(e: ChangeEvent<HTMLInputElement>) => setValid(isBeaconAddressValidOrEmpty(e.target.value.trim()))}
               onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
                   if (e.key === "Enter") {
                       const nextValue = e.currentTarget.value.trim();
                       const isValidNow = isBeaconAddressValidOrEmpty(nextValue);
                       setValid(isValidNow);
                       if (isValidNow) {
                           onBeaconAddressChange(nextValue.toUpperCase(), index);
                           e.currentTarget.blur();
                       } else {
                           e.preventDefault();
                       }
                   }
               }}
        />
    </>
}

export default BeaconAddressInput
